module.exports = __webpack_public_path__ + "img/favicon.4261fc68.png";